if (!customElements.get('background-video')) {
  class BackgroundVideo extends HTMLElement {
    constructor() {
      super();
      this.tl = false;
      this.splittext = false;
      this._muted = true;
    }

    connectedCallback() {
      let _this = this;

      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.prepareAnimations();
      }

      // Video support
      let video_container = this.querySelector('.background-video__iframe');
      if (video_container) {
        if (video_container.querySelector('iframe')) {
          video_container.querySelector('iframe').onload = function () {
            _this.videoPlay(video_container);
          };
        }
      }

      // Mute button
      this._injectMuteButton();
    }

    disconnectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.tl.kill();
        this.splittext.revert();
      }
    }

    videoPlay(video_container) {
      setTimeout(() => {
        if (video_container.dataset.provider === 'youtube') {
          video_container.querySelector('iframe').contentWindow.postMessage(
            JSON.stringify({ event: 'command', func: 'playVideo', args: '' }), '*'
          );
        } else if (video_container.dataset.provider === 'vimeo') {
          video_container.querySelector('iframe').contentWindow.postMessage(
            JSON.stringify({ method: 'play' }), '*'
          );
        }
      }, 10);
    }

    _injectMuteButton() {
      // Only relevant for iframe-based (YouTube/Vimeo) videos
      let video_container = this.querySelector('.background-video__iframe');
      if (!video_container) return;

      let btn = document.createElement('button');
      btn.className = 'background-video__mute-btn';
      btn.setAttribute('aria-label', 'Toggle mute');
      btn.setAttribute('type', 'button');
      btn.innerHTML = `
        <!-- muted icon (speaker with X) -->
        <svg class="icon-mute" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
          <line x1="23" y1="9" x2="17" y2="15"></line>
          <line x1="17" y1="9" x2="23" y2="15"></line>
        </svg>
        <!-- unmuted icon (speaker with waves) -->
        <svg class="icon-unmute" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
          <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
          <path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
        </svg>
      `;

      btn.addEventListener('click', () => this._toggleMute(video_container, btn));
      this.appendChild(btn);
    }

    _toggleMute(video_container, btn) {
      this._muted = !this._muted;

      let iframe = video_container.querySelector('iframe');
      let provider = video_container.dataset.provider;

      // Hosted video (native <video> tag)
      let nativeVideo = video_container.querySelector('video');
      if (nativeVideo) {
        nativeVideo.muted = this._muted;
        btn.classList.toggle('is-unmuted', !this._muted);
        return;
      }

      if (!iframe) return;

      if (provider === 'youtube') {
        let func = this._muted ? 'mute' : 'unMute';
        iframe.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func: func, args: '' }), '*'
        );
      } else if (provider === 'vimeo') {
        let volume = this._muted ? 0 : 1;
        iframe.contentWindow.postMessage(
          JSON.stringify({ method: 'setVolume', value: volume }), '*'
        );
      }

      btn.classList.toggle('is-unmuted', !this._muted);
    }

    prepareAnimations() {
      let section = this,
        button_offset = 0;

      section.tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: 'top center'
        }
      });

      document.fonts.ready.then(function () {
        section.splittext = new SplitText(section.querySelectorAll('h3, p'), {
          type: 'lines, words',
          linesClass: 'line-child'
        });

        if (section.querySelector('h3')) {
          let h3_duration = 0.7 + (section.querySelectorAll('h3 .line-child div').length - 1) * 0.05;
          section.tl.from(section.querySelectorAll('h3 .line-child div'), {
            duration: h3_duration,
            yPercent: '100',
            stagger: 0.05
          }, 0);
          button_offset += h3_duration;
        }
        if (section.querySelector('p')) {
          let p_duration = 0.7 + (section.querySelectorAll('p .line-child div').length - 1) * 0.02;
          section.tl.from(section.querySelectorAll('p .line-child div'), {
            duration: p_duration,
            yPercent: '100',
            stagger: 0.02
          }, 0);
          button_offset += p_duration;
        }
        if (section.querySelector('.video-lightbox-modal__button')) {
          section.tl.fromTo(
            section.querySelector('.video-lightbox-modal__button'),
            { autoAlpha: 0 },
            { duration: 0.5, autoAlpha: 1 },
            button_offset * 0.4
          );
        }
      });
    }
  }
  customElements.define('background-video', BackgroundVideo);
}